import { Outlet } from 'react-router-dom';

export function UnprotectedLayout() {
  const isPrivacyPolicy = window.location.pathname === '/privacy-policy';

  return (
    <div className={`h-[100vh] bg-page-gradient ${isPrivacyPolicy ? 'overflow-y-auto' : ''}`}>
      <Outlet />
    </div>
  );
}
